import VueLoading from 'vuejs-loading-plugin'
import Vue from 'vue'

Vue.use(VueLoading, {
  dark: true, // default false
  background: 'rgba(100, 100, 100, 0.3)', // set custom background
})
